import React from "react";
import moment from "moment";
import DateRangePicker from "../DateRangePicker";

const toDate = (text) => (text ? moment(text, "YYYY-MM-DD").toDate() : null);
const toText = (date) => (date ? moment(date).format("YYYY-MM-DD") : "");

/**
 * Search bar of a history timeline: text, one log-date range (From - To, with presets), the shown count,
 * Clear filters and Export to Excel. filters = { text, from, to } (dates yyyy-MM-dd); onChange(next filters).
 */
export default function ActivityHistoryToolbar({ filters, onChange, shown, total, onExport }) {
  const set = (field) => (e) => onChange({ ...filters, [field]: e.target.value });
  const filtered = Boolean(filters.text || filters.from || filters.to);
  return (
    <div className="mst-history__toolbar" role="search">
      <div className="mst-history__search">
        <i className="fas fa-search" aria-hidden="true" />
        <input
          type="search"
          className="form-control form-control-sm"
          placeholder="Search user, change, vendor..."
          aria-label="Search history"
          value={filters.text}
          onChange={set("text")}
        />
      </div>
      <div className="mst-history__date">
        <DateRangePicker
          startDate={toDate(filters.from)}
          endDate={toDate(filters.to)}
          placeholder="Log date: dd/MM/yyyy - dd/MM/yyyy"
          ariaLabel="Log date range"
          onChange={([start, end]) => onChange({ ...filters, from: toText(start), to: toText(end) })}
        />
      </div>
      <span className="mst-history__count">
        {filtered ? `${shown} of ${total}` : total} {total === 1 ? "entry" : "entries"}
      </span>
      {filtered && (
        <button type="button" className="btn btn-link btn-sm" onClick={() => onChange({ text: "", from: "", to: "" })}>
          Clear filters
        </button>
      )}
      <button
        type="button"
        className="btn btn-outline-primary btn-sm mst-history__export"
        disabled={!shown}
        onClick={onExport}
        title={filtered ? "Export the entries shown" : "Export all entries"}
      >
        <i className="fas fa-file-excel" aria-hidden="true" /> Export to Excel
      </button>
    </div>
  );
}
